import FeaturedArticlesSection from './FeaturedArticlesSection';

export default FeaturedArticlesSection;
